import * as React from "react";
import { useState } from "react";
import { ButtonToolbar, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { Icon, ConfirmDialog } from "components/common";
import { MoreActions } from "components/common/EntityDataTable";
import { useModalContext } from "common/contexts";
import useFeature from "hooks/useFeature";
import { useDeleteDetectionChain } from "security-app/hooks/useDetectionChainsAPI";
import EnableChainAction from "./EnableChainAction";
import { DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG } from "./constants";
const DetectionChainRowActions = ({ chain }) => {
  const managementEnabled = useFeature(DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG);
  const { setModal, setEntity } = useModalContext();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const { mutate: deleteChain } = useDeleteDetectionChain();
  const immutable = chain.scope === "ILLUMINATE";
  const onEdit = () => {
    setEntity(chain);
    setModal("EDIT-CHAIN");
  };
  const onConfirmDelete = () => {
    deleteChain({ id: chain.id, name: chain.name });
    setShowDeleteConfirm(false);
  };
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(EnableChainAction, { chain }), managementEnabled && /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(MenuItem, { disabled: immutable, onClick: onEdit }, /* @__PURE__ */ React.createElement(Icon, { name: "edit_square", size: "xs" }), " Edit"), /* @__PURE__ */ React.createElement(DeleteMenuItem, { disabled: immutable, onClick: () => setShowDeleteConfirm(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete", size: "xs" }), " Delete")), showDeleteConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: "Delete detection chain",
      show: true,
      onConfirm: onConfirmDelete,
      onCancel: () => setShowDeleteConfirm(false)
    },
    `Delete detection chain "${chain.name}"? This does not change the chain's event definitions.`
  ));
};
export default DetectionChainRowActions;
